import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import Small from 'UIComponents/elements/Small';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import PriceDisplay from '../common/pricing/PriceDisplay';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { HUBSPOT_FOR_STARTUPS_SETUP } from 'self-service-api/constants/ApiNames';
import { getOnboardingServicesUrlPublic } from 'pricing-pages-lib/utils/publicPageUrls';
import FormattedMessage from 'I18n/components/FormattedMessage';
const CrossedOutPrice = styled(PriceDisplay).withConfig({
  displayName: "RequiredOnboardingSubtext__CrossedOutPrice",
  componentId: "n834fw-0"
})(["text-decoration:line-through;"]);
const BringAttention = styled.b.withConfig({
  displayName: "RequiredOnboardingSubtext__BringAttention",
  componentId: "n834fw-1"
})([""]);

const RequiredOnboardingSubtext = ({
  langKey,
  pricingInfo,
  currencyCode,
  tab,
  trackingSource
}) => {
  const onboardingServicesUrl = getOnboardingServicesUrlPublic(HUBSPOT_FOR_STARTUPS_SETUP === langKey);

  const handleClick = () => {
    getUsageTracker().track('externalLinkClick', {
      name: 'onboarding-services',
      url: onboardingServicesUrl,
      tab,
      trackingSource
    });
  };

  return /*#__PURE__*/_jsxs(Small, {
    children: [pricingInfo.oneTimeFee.fullPrice > pricingInfo.oneTimeFee.calculatedPrice ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: `planBuilder.requiredOnboardingSubtext.${langKey}-with-discount_jsx`,
      options: {
        currencyCode,
        fullPrice: pricingInfo.oneTimeFee.fullPrice,
        discountedPrice: pricingInfo.oneTimeFee.calculatedPrice
      },
      elements: {
        PriceDisplay,
        CrossedOutPrice,
        b: BringAttention
      }
    }) : /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: `planBuilder.requiredOnboardingSubtext.${langKey}_jsx`,
      options: {
        currencyCode,
        price: pricingInfo.oneTimeFee.calculatedPrice
      },
      elements: {
        PriceDisplay,
        b: BringAttention
      }
    }), "\xA0", /*#__PURE__*/_jsxs(UILink, {
      external: true,
      onClick: handleClick,
      href: onboardingServicesUrl,
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "planBuilder.requiredOnboardingSubtext.learnMore"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        className: "sr-only",
        message: `planBuilder.requiredOnboardingSubtext.onboarding.${langKey}`
      })]
    })]
  });
};

export default RequiredOnboardingSubtext;